import React from 'react';
import {LoginFormUI} from '../../components/forms/LoginFormUI';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { login } from '@Modules/auth/api/auth.api';
import URLConfig from '@Config/urls/url.config';
import loginFormMeta from './LoginFormMeta';

export default function LoginFormHandle() {

  const navigate = useNavigate();

  const { mutate, isLoading: isSubmitting } = useMutation(login, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      navigate(URLConfig.HOME.DASHBOARD);
    },
    onError: (error) => {
      console.log('Error: ', error);
    }
  })

  const handleLogin = (e: any) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const login: string = formData.get('login') as string;
    const password: string = formData.get('password') as string;

    // console.log(login, password);
    // Call Tanstack
    mutate({ login, password});
  };

  return (
    <>
      <LoginFormUI isSubmitting={isSubmitting} onSubmit={handleLogin} meta={loginFormMeta} />
    </>
  );
}
